import React from 'react';
import PropTypes from 'prop-types';
import Alert, { AlertTypes } from 'DesignSystem/Notifications/Alert';

const ModalError = ({ errorCopy }) => {
  if (!errorCopy) {
    return null;
  }
  return (
    <Alert
      className="ds-modal-error-banner"
      text={errorCopy}
      type={AlertTypes.Error}
    />
  );
};

ModalError.defaultProps = {
  errorCopy: '',
};

ModalError.propTypes = {
  errorCopy: PropTypes.string,
};

export default ModalError;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/FormSwiftModal/ModalError.jsx